import { useEffect, useRef } from 'react';

/**
 * Hook to listen for custom notification events on the window object
 * Matches standard Blocks-OS notification listener pattern
 * @param notificationName - The name of the custom event or channel to listen for
 * @param callback - Function to call when the event is triggered
 */
export const useNotificationListener = (
  notificationName: string,
  callback: (data: unknown) => void
) => {
  // Keep the latest callback so inline handlers see fresh state without re-subscribing,
  // which could drop events dispatched between unsubscribe and subscribe.
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const handleNotification = (event: Event) => {
      const customEvent = event as CustomEvent;
      callbackRef.current(customEvent.detail);
    };

    window.addEventListener(notificationName, handleNotification as EventListener);

    return () => {
      window.removeEventListener(notificationName, handleNotification as EventListener);
    };
  }, [notificationName]);
};
